const KEY = 'activeTasks';
const STALE_MS = 60 * 60 * 1000; // 1 час

function _read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
}

function _write(tasks) {
  localStorage.setItem(KEY, JSON.stringify(tasks));
}

/** Добавляет или обновляет задачу в localStorage. */
export function saveTask(task) {
  const tasks = _read();
  const idx = tasks.findIndex(t => t.taskId === task.taskId);
  if (idx >= 0) tasks[idx] = task;
  else tasks.push(task);
  _write(tasks);
}

/** Удаляет задачу из localStorage по taskId. */
export function removeTask(taskId) {
  _write(_read().filter(t => t.taskId !== taskId));
}

/** Возвращает задачи для компонента, предварительно очищая протухшие. */
export function getTasksForComponent(component) {
  clearStaleTasks();
  return _read().filter(t => t.component === component);
}

/**
 * Удаляет протухшие задачи: по собственному `ttlMs`, а если его нет — по общему часу.
 *
 * 🔴 Срок жизни — свойство ЗАДАЧИ, а не модуля. Час придуман под транскрибацию
 * файла, но бот сидит на встрече до четырёх часов (bit-meetbot MAX_MEETING_SEC),
 * а сама встреча остаётся известной сервису сутки (MEETING_TASK_TTL_SEC). С общим
 * часом вкладка, перезагруженная посреди встречи, забывала бы про неё навсегда.
 */
export function clearStaleTasks() {
  const now = Date.now();
  _write(_read().filter(t => now - new Date(t.startedAt).getTime() < (t.ttlMs || STALE_MS)));
}
